import React from "react";
import { Modal, Form, Button, message } from "antd";
import { formItemLayout, tailFormItemLayout } from "$ACTIONS/constantsData";
import moment from "moment";
import dynamic from "next/dynamic";
import "moment/locale/th";
moment.locale("th", {
    //月份
    monthsShort: [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
        "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
    ],
});
const DatePicker = dynamic(import("antd/lib/date-picker"), {
    loading: () => (
        <div className="ant-skeleton ant-skeleton-with-avatar ant-skeleton-active">
            <div className="ant-skeleton-content">
                <ul className="ant-skeleton-paragraph">
                    <li></li>
                </ul>
            </div>
        </div>
    ),
});

const { Item } = Form;

class DateRange extends React.Component {
    static defaultProps = {
        dateRangeLimit: 90,
        selectRangeLimit: 7,
    };
    constructor(props) {
        super(props);

        const startValue = moment()
            .subtract(this.props.selectRangeLimit - 1, "days")
            .startOf("day");
        const endValue = moment().endOf("day");
        this.minTime = moment()
            .subtract(this.props.dateRangeLimit - 1, "days")
            .startOf("day")
            .valueOf();
        this.maxTime = endValue.valueOf();

        this.state = {
            startTime: startValue.valueOf(), // Convert to timestamp
            endTime: endValue.valueOf(), // Convert to timestamp
            mode: "",
        };
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.closeRange();
                this.props.setDate({
                    startTime: moment(values.startTime).format("YYYY-MM-DD"),
                    endTime: moment(values.endTime).format("YYYY-MM-DD"),
                });
            }
        });
    };
    disabledDate = (value) => {
        const { startTime, endTime, mode } = this.state;
        const { selectRangeLimit } = this.props;
        const currentStartValue = moment(value).startOf("day").valueOf(); // Convert to timestamp
        const currentEndValue = moment(value).endOf("day").valueOf(); // Convert to timestamp
        const tooEarly = value && currentStartValue < this.minTime;
        const tooLate = value && currentEndValue > this.maxTime;
        if (startTime && !endTime) {
            return (
                tooEarly ||
                tooLate ||
                (mode === "end" &&
                    (currentStartValue <
                        moment(startTime).startOf("day").valueOf() ||
                        currentStartValue >
                            moment(startTime)
                                .startOf("day")
                                .add(selectRangeLimit - 1, "days")
                                .valueOf()))
            );
        }
        if (!startTime && endTime) {
            return (
                tooEarly ||
                tooLate ||
                (mode === "start" &&
                    (currentEndValue <
                        moment(endTime)
                            .endOf("day")
                            .subtract(selectRangeLimit - 1, "days")
                            .valueOf() ||
                        currentEndValue >
                            moment(endTime).endOf("day").valueOf()))
            );
        }
        return tooEarly || tooLate;
    };
    onChange = (field, value) => {
        const otherField = field === "startTime" ? "endTime" : "startTime";
        if (this.state.startTime && this.state.endTime) {
            this.setState({ [field]: value.valueOf(), [otherField]: null });
            this.props.form.setFieldsValue({
                [otherField]: null,
            });
        } else {
            this.setState({ [field]: value.valueOf() });
        }
    };
    onOpen = (val) => {
        this.setState({ mode: val });
    };
    //處理日期style
    dateRender = (current) => {
        let className = "ant-calendar-date";
        const { startTime, endTime } = this.state;
        if (
            startTime &&
            endTime &&
            current.isBetween(startTime, endTime, "day", "[]")
        ) {
            if (
                current.isSame(startTime, "day") &&
                current.isSame(endTime, "day")
            ) {
                className = "ant-calendar-date selected-day";
            } else if (current.isSame(startTime, "day")) {
                className = "ant-picker-cell-inner selected-day";
                return (
                    <div className={className}>
                        <div />
                        <div className="left-circle">
                            <div className="circle">{current.date()}</div>
                        </div>
                        <div className="after-circle" />
                    </div>
                );
            } else if (current.isSame(endTime, "day")) {
                className = "ant-picker-cell-inner selected-day";
                return (
                    <div className={className}>
                        <div className="pre-circle" />
                        <div className="right-circle">
                            <div className="circle">{current.date()}</div>
                        </div>
                        <div />
                    </div>
                );
            } else {
                className = "ant-picker-cell-inner";
            }
        } else if (
            (startTime && current.isSame(startTime, "day")) ||
            (endTime && current.isSame(endTime, "day"))
        ) {
            className = "ant-calendar-date selected-day";
        }
        return <div className={className}>{current.date()}</div>;
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const defaultValueForStartTime = moment(this.state.startTime);
        const defaultValueForEndTime = moment(this.state.endTime);

        return (
            <Modal
                className={`betRecords-dateRange ${this.props.classNameModal}`}
                title={"รูปแบบวันที่แบบกำหนดเอง"} //自定义日期范围
                visible={this.props.visible}
                onCancel={this.props.closeRange}
                width={400}
                footer={null}
            >
                <Form
                    className="verification-form-wrap"
                    {...formItemLayout}
                    onSubmit={this.handleSubmit}
                >
                    <div className="betRecords-dateRange-hint">
                        <div className="">
                            ช่วงเวลาการค้นหาคือ 7 วัน
                            และสามารถดูประวัติย้อนหลังได้ 90 วัน
                            {/* 默认搜索时间范围为7天，并可搜索 90
                                天之内的交易记录。 */}
                        </div>
                    </div>

                    <Item label="จากวันที่">
                        {/* 开始日期 */}
                        {getFieldDecorator("startTime", {
                            initialValue: defaultValueForStartTime,
                            rules: [
                                {
                                    required: true,
                                    message: "กรุณาเลือกวันที่",
                                },
                                //请选择开始日期！
                            ],
                        })(
                            <DatePicker
                                size="large"
                                showToday={false}
                                allowClear={false}
                                dropdownClassName={`disabled-date ${this.props.classNameDatePicker}`}
                                style={{ width: "100%" }}
                                defaultPickerValue={defaultValueForStartTime}
                                disabledDate={this.disabledDate}
                                format="DD/MM/YYYY"
                                placeholder="กรุณาเลือกวันที่" //请选择开始日期
                                onChange={(v) => {
                                    this.onChange("startTime", v);
                                }}
                                onOpenChange={() => {
                                    this.onOpen("start");
                                }}
                                dateRender={this.dateRender}
                            />
                        )}
                    </Item>
                    <Item label="ถึงวันที่">
                        {/* 结束日期 */}
                        {getFieldDecorator("endTime", {
                            initialValue: defaultValueForEndTime,
                            rules: [
                                {
                                    required: true,
                                    message: "กรุณาเลือกวันที่",
                                }, //请选择结束日期
                            ],
                        })(
                            <DatePicker
                                size="large"
                                showToday={false}
                                allowClear={false}
                                dropdownClassName={`disabled-date ${this.props.classNameDatePicker}`}
                                style={{ width: "100%" }}
                                defaultPickerValue={defaultValueForEndTime}
                                disabledDate={this.disabledDate}
                                format="DD/MM/YYYY"
                                placeholder="กรุณาเลือกวันที่" //请选择结束日期
                                onChange={(v) => {
                                    this.onChange("endTime", v);
                                }}
                                onOpenChange={() => {
                                    this.onOpen("end");
                                }}
                                dateRender={this.dateRender}
                            />
                        )}
                    </Item>
                    <div className="line-distance"></div>
                    <Item {...tailFormItemLayout}>
                        <div className="btn-wrap">
                            <Button
                                size="large"
                                type="primary"
                                htmlType="submit"
                                block
                            >
                                ส่ง
                                {/* 提交 */}
                            </Button>
                        </div>
                    </Item>
                </Form>
            </Modal>
        );
    }
}

export default Form.create({ name: "DateRange" })(DateRange);
